<template>
  <nav
    class="l-navigationmain navigationmain"
    role="navigation"
    aria-label="navigation">
    <ul>
      <item-left-menu
        :link="link"
        v-for="(link, i) in links"
        :key="i + '-' + link.routeName"></item-left-menu>
    </ul>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import { orderBy } from 'lodash'

export default {
  name: 'LayoutLeftMenu',
  components: {
    ItemLeftMenu: () => import('./ItemLeftMenu')
  },
  data () {
    return {
      linksData: {
        home: {
          position: 0,
          enabled: true,
          routeName: 'Dashboard',
          routeType: 'Dashboard',
          text: 'Accueil',
          iconClasses: ['fal', 'fa-columns', 'is-size-1'],
          needProfile: ['admin'],
          needAccount: ['promoteur']
        },
        stock: {
          position: 1,
          enabled: true,
          routeName: 'ProgramCardList',
          routeType: 'Stock',
          text: 'Stocks',
          iconClasses: ['fal', 'fa-city', 'is-size-1'],
          children: [
            {
              routeName: 'ProgramCardList',
              routeType: 'Stock',
              children: [
                {
                  routeName: 'ProgramCardList',
                  routeType: 'Stock',
                  text: 'Programmes et lots'
                },
                {
                  routeName: 'OptionList',
                  routeType: 'Stock',
                  text: 'Options en cours'
                }
                /* {
                    routeName: 'LotWishlistList',
                    text: 'Favoris',
                    badge: 'wishlists'
                  }, */
              ]
            },
            {
              routeName: 'AccessList',
              routeType: 'Access',
              needProfile: ['admin'],
              children: [
                {
                  routeName: 'AccessList',
                  routeType: 'Access',
                  text: 'Mandats de commercialisation'
                }
              ]
            }
          ]
        },
        contacts: {
          position: 2,
          enabled: true,
          routeName: 'ContactList',
          routeType: 'Contact',
          iconClasses: ['fal', 'fa-id-card', 'is-size-1'],
          text: 'Contacts',
          children: [
            {
              routeName: 'ContactList',
              routeType: 'Contact',
              iconClasses: ['fa-lg', 'fal', 'fa-id-card'],
              children: [
                {
                  routeName: 'ContactList',
                  routeType: 'Contact',
                  text: 'Contacts'
                },
                /* {
                    routeName: 'ContactCreate',
                    routeType: 'Contact',
                    text: 'Ajouter un contact'
                  }, */
                {
                  routeName: 'DenunciationList',
                  routeType: 'Contact',
                  text: 'Dénonciations'
                }
              ]
            },
            {
              routeName: 'TiersList',
              routeType: 'Contact',
              children: [
                {
                  routeName: 'TiersList',
                  routeType: 'Contact',
                  text: 'Tiers'
                }
              ]
            },
            {
              routeName: 'OriginList',
              routeType: 'Contact',
              needProfile: ['admin'],
              children: [
                {
                  routeName: 'OriginList',
                  routeType: 'Contact',
                  text: 'Origines des contacts'
                }
                /* {

                    routeName: 'OriginCreate',
                    routeType: 'Contact',
                    text: 'Ajouter une origine',
                    iconClasses: ['fal', 'fa-plus-circle']
                  } */
              ]
            }
          ]
        },
        calendar: {
          enabled: false,
          position: 3,
          routeType: 'Calendar',
          routeName: 'CalendarMonth',
          text: 'Calendrier',
          iconClasses: ['fal', 'fa-calendar-alt', 'is-size-1']
        },
        users: {
          position: 4,
          enabled: false,
          routeName: 'UserList',
          routeType: 'User',
          text: 'Utilisateurs',
          iconClasses: ['fal', 'fa-users', 'is-size-1'],
          children: [
            {
              routeName: 'UserList',
              routeType: 'User',
              children: [
                {
                  routeName: 'UserList',
                  routeType: 'User',
                  text: 'Utilisateurs'
                }
                /* {
                    routeName: 'UserCreate',
                    routeType: 'User',
                    needProfile: ['admin', 'manager'],
                    text: 'Ajouter un utilisateur',
                    iconClasses: ['fal', 'fa-plus-circle']
                  } */
              ]
            },
            {
              routeName: 'GroupListInterne',
              routeType: 'User',
              children: [
                {
                  routeName: 'GroupListInterne',
                  routeType: 'User',
                  text: 'Groupes'
                }
                /* {
                    routeName: 'GroupCreate',
                    routeType: 'User',
                    text: 'Nouveau groupe',
                    iconClasses: ['fal', 'fa-plus-circle']
                  } */
              ]
            }
          ]
        },
        adv: {
          position: 5,
          enabled: true,
          routeName: 'AdvList',
          routeType: 'Adv',
          iconClasses: ['fal', 'fa-tasks', 'is-size-1'],
          text: 'ADV',
          needProfile: ['admin', 'manager', 'seller']
        },
        stats: {
          position: 6,
          enabled: false,
          routeName: 'StatsSales',
          routeType: 'Stats',
          iconClasses: ['fal', 'fa-tachometer-alt', 'is-size-1'],
          text: 'Statistiques',
          children: [
            {
              routeName: 'StatsSales',
              children: [
                {
                  routeName: 'StatsSales',
                  routeType: 'Stats',
                  text: 'Ventes'
                },
                {
                  routeName: 'StatsSellers',
                  routeType: 'Stats',
                  text: 'Vendeurs'
                },
                // {
                //   configs: ['MULTIDIFF_ENABLED'],
                //   routeName: 'StatsMultidiffusion',
                //   text: 'StatsMultidiffusion'
                // },
                {
                  routeName: 'StatsRdvs',
                  routeType: 'Stats',
                  text: 'Rendez-vous'
                }
              ]
            }
          ]
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isManager', 'isPromoteur', 'canAddUsers', 'isDistributeur', 'canUseCalendar', 'statsEnabled', 'canUseContactSharing']),
    links () {
      let links = this.linksData
      links = Object.values(links)
      links = links.filter(x => x.enabled)
      return orderBy(links, 'position')
    }
  },
  created () {
    if (this.isAdmin && this.isPromoteur) {
      this.linksData.stock.children.push({
        routeName: 'ChannelListVue',
        routeType: 'Channel',
        children: [
          {
            routeName: 'ChannelListVue',
            routeType: 'Channel',
            text: 'Canaux de vente'
          }
        ]
      })
      this.linksData.stock.children.push({
        routeName: 'AgenceListVue',
        routeType: 'Agence',
        children: [
          {
            routeName: 'AgenceListVue',
            routeType: 'Agence',
            text: 'Agence'
          }
        ]
      })
      // let newAccess = {
      //   routeName: 'AccessCreate',
      //   routeType: '',
      //   text: 'Nouveau mandat',
      //   iconClasses: ['fal', 'fa-plus-circle'],
      //   needAccount: ['promoteur']
      // }
      // this.linksData.stock.children[1].children.push(newAccess)
      // let newProgramEntry = {
      //   routeName: 'ProgramCreate',
      //   routeType: '',
      //   text: 'Nouveau programme',
      //   iconClasses: ['fal', 'fa-plus-circle']
      // }
      // this.linksData.stock.children[0].children.push(newProgramEntry)
    }
    if (this.canUseCalendar) {
      this.linksData.calendar.enabled = true
    }
    if ((this.isAdmin || this.isManager) && this.canAddUsers) {
      this.linksData.users.enabled = true
    }
    if (this.isAdmin && this.canAddUsers) {
      let children = [
        {
          routeName: 'UserList',
          routeType: 'User',
          children: [
            {
              routeName: 'UserList',
              routeType: 'User',
              text: 'Utilisateurs interne'
            }
          ]
        },
        {
          routeName: 'GroupListInterne',
          routeType: 'User',
          children: [
            {
              routeName: 'GroupListInterne',
              routeType: 'User',
              text: 'Groupes'
            }
          ]
        }
      ]
      this.linksData.users.children = children
    }
    if (this.isAdmin) {
      let children = {
        routeName: 'RelationsList',
        routeType: 'User',
        children: [
          {
            routeName: 'RelationsList',
            routeType: 'User',
            text: 'Relations externe'
          }
        ]
      }
      this.linksData.users.children.splice(1, 0, children)
    }
    if (this.isManager) {
      delete this.linksData.users.children
    }
    if (this.statsEnabled && (this.isAdmin && this.isPromoteur)) {
      this.linksData.stats.enabled = true
    }
    if (this.canUseContactSharing && this.isAdmin) {
      this.linksData.contacts.children.push({
        routeName: 'ShareIntentList',
        routeType: 'Contact',
        children: [
          {
            routeName: 'ShareIntentList',
            routeType: 'Contact',
            text: 'Partage de contact'
          }
        ]
      })
    }
  }
}
</script>
